import { omit } from './objectHelpers';


export const cleanUpSsapJson = (data, propsForMerge) => {

    const resolve = (data, pathChunks, valueForMerge) => {

        const [ currentPathChunk, ...restPath ] = pathChunks;

        if(!currentPathChunk) {
            return data;
        }

        if(pathChunks.length === 1) {
            if(valueForMerge && valueForMerge.propsForMerge === true) {
                return {
                    ...cleanUpSsapJson(data, omit(valueForMerge, 'propsForMerge'))
                };
            } else {
                return {
                    ...data,
                    [currentPathChunk]: valueForMerge
                };
            }
        } else {
            return {
                ...data,
                [currentPathChunk]: merge(data[currentPathChunk], restPath, valueForMerge)
            };
        }
    };

    const merge = (data, pathChunks, valueForMerge) => {

        const [ currentPathChunk, ...restPath ] = pathChunks;

        if(currentPathChunk.includes('[i]')) {
            const name = currentPathChunk.slice(0, -3);
            return {
                ...data,
                [name]: data[name].map(item => {
                    const [ nextPathChunk ] = restPath;
                    return item[nextPathChunk] ? merge(item, restPath, valueForMerge) : resolve(item, nextPathChunk ? restPath : [ name ], valueForMerge);
                })
            };
        }

        return resolve(data, pathChunks, valueForMerge);

    };

    return Object.entries(propsForMerge).reduce((res, [ path, valueForMerge ]) => {
        const pathChunks = path.split('.');
        return merge(res, pathChunks, valueForMerge);
    }, data);
};